import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Formato } from "../types"
import { API_URL } from "../constants"

export function useFormatiList(params: Record<string, string> = {}) {
  return useList<Formato>(`${API_URL}/formati`, {
    query: {
      page_size: 200,
      ...params,
    },
  })
}

export function useFormato(id: number | undefined | string) {
  return useDetail<Formato>(`${API_URL}/formati`, id?.toString())
}

export function useFormatoCreate() {
  return useCreate<Formato>(`${API_URL}/formati`)
}

export function useFormatoUpdate() {
  return useUpdate<Formato>(`${API_URL}/formati`)
}

export function useFormatoDelete() {
  return useDelete<Formato>(`${API_URL}/formati`)
}

